/**
 * Copy-paste snippets the onboarding drawer hands an operator at the
 * "Await script installation" step.
 */

/**
 * The only shapes ever interpolated into a customer's page for these IDs —
 * matches Google's own format. An unsafe value here is a script-breakout on a
 * live customer site, not just a broken tag, so a bad value is swapped for
 * the harmless placeholder rather than pasted through.
 */
export const SAFE_GTM_CONTAINER_ID_RE = /^GTM-[A-Z0-9]+$/i;
export const SAFE_GA4_MEASUREMENT_ID_RE = /^G-[A-Z0-9]+$/i;

function safeGtmContainerId(containerId: string): string {
  return SAFE_GTM_CONTAINER_ID_RE.test(containerId)
    ? containerId
    : "GTM-XXXXXXX";
}

function safeMeasurementId(measurementId: string): string {
  return SAFE_GA4_MEASUREMENT_ID_RE.test(measurementId)
    ? measurementId
    : "G-XXXXXXXX";
}

export function buildGtmHeadSnippet(containerId: string): string {
  const id = safeGtmContainerId(containerId);
  return `<!-- Google Tag Manager -->
<script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${id}');</script>
<!-- End Google Tag Manager -->`;
}

export function buildGtmBodySnippet(containerId: string): string {
  const id = safeGtmContainerId(containerId);
  return `<!-- Google Tag Manager (noscript) -->
<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=${id}"
height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
<!-- End Google Tag Manager (noscript) -->`;
}

export function buildGtagSnippet(measurementId: string): string {
  const id = safeMeasurementId(measurementId);
  return `<!-- Google tag (gtag.js) -->
<script async src="https://www.googletagmanager.com/gtag/js?id=${id}"></script>
<script>
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', '${id}');
</script>`;
}
